import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    hidePasscode: 'Hide PIN',
    showPasscode: 'Show PIN',
  },
  fr: {
    hidePasscode: 'Cacher le code PIN',
    showPasscode: 'Afficher le code PIN',
  },
});

export default locales;
